<!-- class="toggletarget togglegroup" -->

<div id="tab-one-b" class="togglegroup margin-top">
  <a class="back u-mb40 toggle global-hand" data-id="tab-one-c" (click)="handleBack.emit()">
    Eliminar equipo
  </a>

  <div class="u-bt u-bt--grey">
    <div class="row">
      <div class="col-md-3 u-pt30 u-pb10">
        <h3 class="txt txt--section">
          {{nameAsset}}
        </h3>
        <p class="txt txt--paragraph">
          Nº:{{numberLicense}}
        </p>
        <h5 class="text-styleH5">Restricciones de conducción:</h5>
        <p class="text-styleP">{{ restrictionDriver}}</p>


      </div>

      <div class="col-md-3 u-pt30 u-pb10">
        <a class="modal__trigger delete global-hand" data-modal="modal02" (click)="onDeleteLicense(licenseSelectedId)"><img class="delete-action-icon" src="/assets/img/icon-delete-orange.png">Eliminar</a>
      </div>
    </div>
    <div class="table-tab">
      <div class="tr">
        <div class="th">
          <h3>
            Vehículos registrados:
          </h3>
        </div>
        <div class="th">
          <h3>
            Zonas registradas:
          </h3>
        </div>
        <div class="th">
          <h3>
            Tipo licencia
          </h3>
        </div>
      </div>
      <div class="tr" *ngFor="let item of detailLicense?.equipments; let i = index;">
        <div class="td" style="vertical-align:baseline !important">
          <div class="u-mb50">
            <h4>
              {{item.equipmentName}}
            </h4>
            <h5 class="txt txt--paragraph txt--grey">
              {{item.equipmentBrand}}- {{item.equipmentModel}}
            </h5>
          </div>

            <a   class="delete button-delete-selected global-hand" (click)="onDeleteEquiment(item.equipmentId)"
            [ngClass]="detailLicense?.equipments!.length === 1 ? 'button-delete-selected-disabled' : ''">
              <img *ngIf="detailLicense?.equipments!.length > 1" class="delete-action-icon" src="/assets/img/icon-delete-orange.png">
              <img *ngIf="detailLicense?.equipments!.length  === 1 " class="delete-action-icon" src="/assets/img/icon-delete.png">
              Eliminar equipo  <span *ngIf="detailLicense?.equipments!.length === 1" >*</span></a>



        </div>
        <div class="separated-line"></div>
        <div class="td" style="vertical-align:baseline !important">
          <div *ngIf="!deletingZone[i]" style=" display: flex;">
            <ul *ngFor="let zones of item.conductionZones; let index = index;">
              <li class="list-select" >
                <a>{{zones.description}}</a>
              </li>
            </ul>
          </div>
          <div *ngIf="deletingZone[i]"   class=" containerButtons" [ngClass]="!deletingZone[i] ? 'global-unmount' : ''">
            <div class="delete-buttons">
              <ng-container *ngFor="let zone of item.conductionZones; let index = index;">
                <a class="delete-button global-hand" (click)="onDeleteZone(item.equipmentId, zone.id)">
                  <span class="delete-circle">X</span>
                  <span class="delete-text">{{zone.description}}</span>
                </a>
              </ng-container>
            </div>
          </div>
          <a *ngIf="!deletingZone[i]"
              class="button-delete-selected delete delete--trigger global-hand"
            (click)="listToSelect(item.equipmentId,'zone')"
            [ngClass]="item.conductionZones.length === 1 && !deletingZone[i] ? 'button-delete-selected-disabled' : ''">
            <img *ngIf="item.conductionZones.length > 1"class="delete-action-icon" src="/assets/img/icon-delete-orange.png">
            <img *ngIf="item.conductionZones.length === 1 && !deletingZone[i]" class="delete-action-icon" src="/assets/img/icon-delete.png">
            Eliminar una zona  <span *ngIf="item.conductionZones.length === 1 && !deletingTypeLicense[i]" >*</span>
          </a>
            <a *ngIf="item.conductionZones.length > 1  && deletingZone[i]" class="back-delete delete--trigger delete-action global-hand"
            (click)="listToSelect(item.equipmentId, 'zone')">
            <img class="back-action-icon" src="/assets/img/arrow_o_l.png">
            Volver
          </a>
        </div>
        <div class="separated-line"></div>
        <div class="td line-before" style="vertical-align:baseline !important">
          <div  *ngIf="!deletingTypeLicense[i]" style="display: flex;">
            <ul  *ngFor="let typesLicences of item.licenseTypes; let index = index;">
              <li class="list-select" >
                <a>{{typesLicences.description}}</a>
              </li>
            </ul>

          </div>
          <div  *ngIf="deletingTypeLicense[i]"   class="containerButtons" [ngClass]="!deletingTypeLicense[i]  ? 'global-unmount' : ''">
            <div class="delete-buttons">
              <ng-container *ngFor="let type of item.licenseTypes; let index = index;">
                <a class="delete-button global-hand" (click)="onDeleteTypeLicense(item.equipmentId,type.id)">
                  <span class="delete-circle">X</span>
                  <span class="delete-text">{{type.description}}</span>
                </a>
              </ng-container>
            </div>
          </div>
          <a *ngIf="!deletingTypeLicense[i]"
              class="button-delete-selected delete delete--trigger global-hand"
              [ngClass]="item.licenseTypes.length === 1 && !deletingTypeLicense[i] ? 'button-delete-selected-disabled' : ''"
              (click)="listToSelect(item.equipmentId,'typeLicense')"
              >
            <img  *ngIf="item.licenseTypes.length > 1 "class="delete-action-icon" src="/assets/img/icon-delete-orange.png">
            <img *ngIf="item.licenseTypes.length === 1 && !deletingTypeLicense[i]" class="delete-action-icon" src="/assets/img/icon-delete.png">
            Eliminar un tipo de licencia <span *ngIf="item.licenseTypes.length === 1 && !deletingTypeLicense[i]" >*</span></a>
            <a *ngIf="item.licenseTypes.length > 1  && deletingTypeLicense[i]" class="back-delete delete--trigger delete-action global-hand4"
              (click)="listToSelect(item.equipmentId, 'typeLicense')">
              <img class="back-action-icon" src="/assets/img/arrow_o_l.png">
              Volver
            </a>
        </div>
      </div>
      <!--row end  -->

    </div>
  </div>
  <div *ngIf="shouldShowWarningMessage" class="container-warning">
    <p class="text-warning">* Estas características no pueden ser eliminadas ya que representan registros únicos dentro de la licencia de conducir, el eliminar uno de ellos eliminaría la licencia de conducir en su completitud.</p>
  </div>
</div>
